export default __webpack_public_path__ + "static/media/Prahis.f17ea4db.jpeg";